<template>
  <div class="content if-profile">
    <div class="md-layout profit-loss">
      <SPIFProfileHeader :headerData="this.headerData" />
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 mt-4">
        <div class="navbar md-toolbar md-transparent md-elevation-4 p-0">
          <h1 class="section_header">Profit &amp; Loss</h1>
          <div class="md-toolbar-row fundamentals_wpr profit-loss  p-0">
            <div class="md-card-nav-tabs">
              <div class="md-toolbar-row fundamentals_area p-0 m-0">
                <nav-tabs-card no-label md-elevation="0">
                  <template slot="content">
                    <md-tabs md-alignment="left" class="p-0">
                      <md-tab v-if="this.display_by_percentages" id="tab-money" md-label="Percentages" md-icon="percent"
                        class="p-0">
                        <div class="md-layout">
                          <div class="md-layout-item p-0">
                            <md-card-header>Percentages</md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-size-100 p-0" v-if="!isSPIF">
                                  <md-table v-model="tableDataFirmPercent" table-header-color="blue"
                                    class="profit-and-loss-table">
                                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                                      <md-table-cell :class="item.name === 'Cost of Sales - Labor Portion'
                                        ? 'md-table-side-label pl-2'
                                        : 'md-table-side-label'">
                                        {{ item.name }}
                                        <md-tooltip md-direction="bottom">
                                          {{
                                            item.rollover
                                          }}
                                        </md-tooltip>
                                      </md-table-cell>

                                      <md-table-cell md-label="Trend" class="table_chart">
                                        <chart-card header-animation="false" :chart-data="colouredLineChart.data"
                                          :chart-options="colouredLineChart.options" chart-type="Line" header-icon
                                          chart-inside-content no-footer background-color="blue"></chart-card>
                                      </md-table-cell>

                                      <md-table-cell v-for="key in Object.keys(item.dates)" :key="key" :md-label="key">{{
                                        item.dates[key] }}</md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                                <div class="md-layout-item md-size-100 p-0">
                                  <md-table v-model="tableDataIndustryPercent" table-header-color="blue"
                                    class="profit-and-loss-table">
                                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                                      <md-table-cell md-label="Parameters" :class="item.name === 'Cost of Sales - Labor Portion'
                                        ? 'md-table-side-label pl-2'
                                        : 'md-table-side-label'">
                                        {{ item.name }}
                                        <md-tooltip md-direction="bottom">
                                          {{
                                            item.rollover
                                          }}
                                        </md-tooltip>
                                      </md-table-cell>

                                      <md-table-cell md-label="Trend" class="table_chart">
                                        <chart-card header-animation="false" :chart-data="colouredLineChart.data"
                                          :chart-options="colouredLineChart.options" chart-type="Line" header-icon
                                          chart-inside-content no-footer background-color="blue"></chart-card>
                                      </md-table-cell>

                                      <md-table-cell v-for="key in Object.keys(item.dates)" :key="key" :md-label="key">{{
                                        item.dates[key] }}%</md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </div>
                        </div>
                      </md-tab>
                      <md-tab v-if="this.display_by_dollars" id="tab-payments" md-label="Dollars" md-icon="payments"
                        class="p-0">
                        <div class="md-layout">
                          <div class="md-layout-item p-0">
                            <md-card class="m-0">
                              <md-card-header>Dollars</md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div class="md-layout-item md-size-100 p-0" v-if="!isSPIF">
                                    <md-table v-model="tableDataFirmDollar" table-header-color="blue"
                                      class="profit-and-loss-table">
                                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                                        <md-table-cell :class="item.name === 'Cost of Sales - Labor Portion'
                                          ? 'md-table-side-label pl-2'
                                          : 'md-table-side-label'">
                                          {{ item.name }}
                                          <md-tooltip md-direction="bottom">
                                            {{
                                              item.rollover
                                            }}
                                          </md-tooltip>
                                        </md-table-cell>

                                        <md-table-cell md-label="Trend" class="table_chart">
                                          <chart-card header-animation="false" :chart-data="colouredLineChart.data"
                                            :chart-options="colouredLineChart.options" chart-type="Line" header-icon
                                            chart-inside-content no-footer background-color="blue"></chart-card>
                                        </md-table-cell>

                                        <md-table-cell v-for="key in Object.keys(item.dates)" :key="key"
                                          :md-label="key">{{ item.dates[key] }}</md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                  <div class="md-layout-item md-size-100 p-0">
                                    <md-table v-model="tableDataIndustryDollar" table-header-color="blue"
                                      class="profit-and-loss-table">
                                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                                        <md-table-cell md-label="Parameters" :class="item.name === 'Cost of Sales - Labor Portion'
                                          ? 'md-table-side-label pl-2'
                                          : 'md-table-side-label'">
                                          {{ item.name }}
                                          <md-tooltip md-direction="bottom">
                                            {{
                                              item.rollover
                                            }}
                                          </md-tooltip>
                                        </md-table-cell>

                                        <md-table-cell md-label="Trend" class="table_chart">
                                          <chart-card header-animation="false" :chart-data="colouredLineChart.data"
                                            :chart-options="colouredLineChart.options" chart-type="Line" header-icon
                                            chart-inside-content no-footer background-color="blue"></chart-card>
                                        </md-table-cell>

                                        <md-table-cell v-for="key in Object.keys(item.dates)" :key="key"
                                          :md-label="key">${{ item.dates[key] }}</md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                        </div>
                      </md-tab>
                    </md-tabs>
                  </template>
                </nav-tabs-card>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavTabsCard, ChartCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
import SPIFProfileHeader from './_partials/SPIFProfileHeader.vue';
import SPIFSidebar from './_partials/SPIFSidebar.vue';

export default {
  components: {
    ChartCard,
    SPIFProfileHeader,
    NavTabsCard,
    // SPIFSidebar
  },
  mixins: [formatData],
  props: ['headerData'],
  data() {
    return {
      view: 'dollar',
      tableDataIndustryDollar: [],
      tableDataIndustryPercent: [],
      tableDataFirmDollar: [],
      tableDataFirmPercent: [],
      tableDataVarianceDollar: [],
      charts: [],
      options: {
        showLabel: false,
        legendNames: [],
        height: '250px',
      },
      display_by_dollars: false,
      display_by_percentages: false,
      display_by_variance: false,
      colouredLineChart: {
        data: {
          labels: [1, 2, 3, 4, 5],
          series: [
            [1, 5, 3, 4, 2]
          ]
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 1,
          }),
          chartPadding: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
          },
          axisY: {
            showGrid: false,
            showLabel: false,
            offset: 0,
          },
          axisX: {
            showGrid: false,
            showLabel: false,
            offset: 0,
            scaleMinSpace: 6
          },
          showPoint: true,
          showLabel: false,
          width: "100px",
          height: "25px",
          seriesBarDistance: 10,
          fullWidth: true,
        },
      },
    };
  },
  computed: {
    ...mapState({
      chartData: (state) => state.user.profile.data.chartData['profitLoss'],
      table: (state) => state.user.profile.data.tables['PL'],
      showYears: (state) => state.user.profile.data.showYears,
      years: (state) => state.user.profile.data.years,
      report: (state) => state.user.profile.data,
      isSPIF: (state) => state.user.profile.spif,
    }),
  },
  mounted() {
    this.$store.commit(
      'user/SET_ACTIVE_SECTION',
      'Profit & Loss'
    );

    let section = this.$route.query.section;

    if (!section) {
      section = 'dollar';
    }

    if (
      this.report.displaySettings.includes('pl_balance_percent') &&
      this.report.displaySettings.includes('pl_balance_dollar')
    ) {
      this.display_by_dollars = true;
      this.display_by_percentages = true;
      // this.display_by_variance = true;
    }
    if (
      this.report.displaySettings.includes('pl_balance_dollar') &&
      !this.report.displaySettings.includes('pl_balance_percent')
    ) {
      this.display_by_dollars = true;
      // this.display_by_variance = true;
    }
    if (
      this.report.displaySettings.includes('pl_balance_percent') &&
      !this.report.displaySettings.includes('pl_balance_dollar')
    ) {
      this.display_by_percentages = true;
      // this.display_by_variance = true;
    }
    if (
      !this.report.displaySettings.includes('pl_balance_percent') &&
      !this.report.displaySettings.includes('pl_balance_dollar')
    ) {
      this.display_by_dollars = false;
      this.display_by_percentages = false;
      // this.display_by_variance = false;
    }
    this.switchView(section);
    let filtered_years = [];
    Object.keys(this.showYears).forEach((k, i) => {
      if (this.showYears[k]) {
        filtered_years.push(this.years[i]);
      }
    });
    if (!filtered_years.length) {
      filtered_years = this.years;
    }

    // this.tableDataVarianceDollar = this.formatTable(
    //   this.table,
    //   'variance',
    //   'dollar'
    // );
    // this.tableDataVarianceDollar = this.tableDataVarianceDollar.map((item) => {
    //   let changeDates = Object.keys(item.dates);
    //   changeDates = changeDates.filter((fItem) => {
    //     return !filtered_years.includes(fItem);
    //   });
    //   let newDates = item.dates;
    //   changeDates.map((el) => {
    //     delete newDates[el];
    //   });
    //   let obj = {
    //     ...item,
    //     dates: newDates,
    //   };

    //   return obj;
    // });

    var rolloverArray = [];
    Object.entries(this.report.glossary_pl).forEach(([index, item]) => {
      rolloverArray[index] = item;
    });

    this.tableDataIndustryDollar = this.formatTable(
      this.table,
      'industry',
      'dollar',
      rolloverArray
    );
    this.tableDataIndustryDollar = this.tableDataIndustryDollar.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });



    this.tableDataIndustryPercent = this.formatTable(
      this.table,
      'industry',
      'percent',
      rolloverArray
    );
    this.tableDataIndustryPercent = this.tableDataIndustryPercent.map(
      (item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      }
    );

    this.tableDataFirmDollar = this.formatTable(this.table, 'firm', 'dollar');
    this.tableDataFirmDollar = this.tableDataFirmDollar.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });

    this.tableDataFirmPercent = this.formatTable(this.table, 'firm', 'percent');
    this.tableDataFirmPercent = this.tableDataFirmPercent.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });

    this.charts = this.formatPieChart(this.chartData);
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'dollar';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    getOptions(newOptions) {
      return {
        ...this.options,
        ...newOptions,
      };
    },
  },
};
</script>
<style lang="scss">
.profit-loss {
  .financal-report-col-1 {
    display: flex;
    align-items: center;

    h4 {
      margin-top: 0;
    }
  }

  .financal-report-col-2 {
    .access-button {
      margin-top: 18px !important;
    }

    .financal-report-col-3 {
      display: flex;
      justify-content: flex-end;
    }
  }

  .heder-titel-col-2 {
    margin-bottom: 35px;
  }

  .summary-scores-box-star {
    .md-button-content {
      .md-icon {
        color: #3b7ef1;
      }
    }

    h4 {
      margin-left: 60px;
    }
  }

  .summary-scores-box-flag {
    .md-icon {
      color: #3b7ef1;
    }

    .w-100 {
      width: 100%;
    }
  }

  .md-collapse-content {
    padding: 0 !important;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }
}
</style>
